/* eslint-disable-next-line no-restricted-imports */
import type { Cart } from '@jane/shared/models';

export const calcNumberOfCartItems = (cart: Cart) =>
  cart.products.reduce((acc, cartProduct) => {
    acc += cartProduct.count;
    return acc;
  }, 0);
